import { useState } from "react";
import { Crown, Clock, Upload, ShieldCheck, Loader2, Check, ChevronRight, Star, Mail, Send } from "lucide-react";
import { api, submitContact } from "../lib/api";

export const SettingsView = ({ premium, expiresAt, monuments, onBuy, onReload, paymentsEnabled }) => {
  const [adminOpen, setAdminOpen] = useState(false);
  const [passcode, setPasscode] = useState("");
  const [selMon, setSelMon] = useState(monuments[0]?.id || "");
    const [contactOpen, setContactOpen] = useState(false);
  const [contactMsg, setContactMsg] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactSent, setContactSent] = useState(false);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [msg, setMsg] = useState("");

  const expText = expiresAt
    ? new Date(expiresAt).toLocaleString("es-ES", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })
    : "";

  const upload = async () => {
    if (!file || !selMon || !passcode) {
      setMsg("Completa clave, monumento y vídeo.");
      return;
    }
    setUploading(true);
    setMsg("");
    try {
      const fd = new FormData();
      fd.append("passcode", passcode);
      fd.append("file", file);
      await api.post(`/admin/monuments/${selMon}/video`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setMsg("✓ Vídeo subido correctamente.");
      setFile(null);
      onReload?.();
    } catch (e) {
      setMsg(e?.response?.status === 403 ? "Clave incorrecta." : "Error al subir el vídeo.");
    }
    setUploading(false);
  };

  return (
    <div className="min-h-screen pt-16 pb-40 px-5">
      <span className="text-[11px] tracking-[0.3em] uppercase" style={{ color: "#8c7326" }}>Tu visita</span>
      <h1 className="font-serif-display text-4xl leading-none mt-1 mb-6" style={{ color: "#f3f4f6" }}>Ajustes</h1>

      {/* Estado de acceso */}
      <div className="glass rounded-2xl p-5 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: "rgba(212,175,55,0.12)", border: "1px solid rgba(212,175,55,0.25)" }}>
            <Crown size={20} className="gold-text" />
          </div>
          <div className="flex-1">
            <p className="font-serif-display text-xl leading-none" style={{ color: "#f3f4f6" }}>
              {paymentsEnabled ? (premium ? "Acceso activo" : "Acceso gratuito") : "Acceso libre"}
            </p>
            {paymentsEnabled && premium ? (
              <p className="text-xs flex items-center gap-1 mt-1" style={{ color: "#9ca3af" }}>
                <Clock size={12} /> Válido hasta {expText}
              </p>
            ) : (
              <p className="text-xs mt-1" style={{ color: "#9ca3af" }}>
                {paymentsEnabled ? "Desbloquea todos los audios y vídeos" : "Todos los monumentos disponibles"}
              </p>
            )}
          </div>
        </div>
        {paymentsEnabled && !premium && (
          <button data-testid="settings-buy-btn" onClick={onBuy} className="btn-gold w-full rounded-full py-3 mt-4 text-sm">
            Obtener acceso · 4,99 €
          </button>
        )}
      </div>

      <div className="mt-8 pt-6" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        
        <a
          href="https://g.page/r/review"
          target="_blank"
          rel="noreferrer"
          data-testid="review-link-btn"
          className="w-full rounded-full py-3.5 flex items-center justify-center gap-2 text-sm mb-3"
          style={{ background: "rgba(212,175,55,0.10)", border: "1px solid rgba(212,175,55,0.3)", color: "#f0c94a" }}
        >
          <Star size={16} /> Déjanos una reseña
        </a>

        {!contactOpen ? (
          <button
            data-testid="contact-open-btn"
            onClick={() => setContactOpen(true)}
            className="w-full rounded-full py-3.5 flex items-center justify-center gap-2 text-sm"
            style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", color: "#9ca3af" }}
          >
            <Mail size={16} /> Contáctanos
          </button>
        ) : contactSent ? (
          <p className="text-center text-sm py-3" style={{ color: "#4ade80" }}>
            <Check size={16} className="inline mr-1" /> ¡Gracias! Hemos recibido tu mensaje.
          </p>
        ) : (
          <div className="space-y-2">
            <input
              data-testid="contact-email-input"
              type="email"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
              placeholder="Tu email (opcional)"
              className="w-full rounded-xl px-4 py-2.5 text-sm bg-transparent outline-none"
              style={{ border: "1px solid rgba(255,255,255,0.1)", color: "#f3f4f6" }}
            />
            <textarea
              data-testid="contact-message-input"
              value={contactMsg}
              onChange={(e) => setContactMsg(e.target.value)}
              placeholder="Cuéntanos qué te ha parecido o qué podemos mejorar…"
              rows={3}
              className="w-full rounded-xl px-4 py-2.5 text-sm bg-transparent outline-none resize-none"
              style={{ border: "1px solid rgba(255,255,255,0.1)", color: "#f3f4f6" }}
            />
            <button
              data-testid="contact-send-btn"
              disabled={!contactMsg.trim()}
              onClick={async () => {
                try {
                  await submitContact(contactMsg.trim(), contactEmail.trim());
                  setContactSent(true);
                } catch (e) {}
              }}
              className="btn-gold w-full rounded-full py-3 text-sm flex items-center justify-center gap-2 disabled:opacity-50"
            >
              <Send size={15} /> Enviar
            </button>
          </div>
        )}
      </div>
      <p className="text-center text-[11px] mt-8" style={{ color: "#4b5563" }}>
        Audioguía de Lerma · Siglo de Oro · Hecho en Lerma 
      </p>
    </div>
  );
};
